import {usePage} from "@inertiajs/react";

export function useConfig() {
    return usePage().props.config;
}
